import { IconFilmnetLogo } from '../../../icons';
import { WatermarkContainer } from '../../Player/styles';

const Watermark = () => (
  <WatermarkContainer>
    <IconFilmnetLogo />
  </WatermarkContainer>
);

export default Watermark;
